import { cn } from "@/lib/utils";
import { trustChip, toneSurface } from "./labels";
import { useSourceCredibility } from "@/hooks/useResearchHubTrust";

// A quiet reliability chip on a citation. Pass a pre-fetched `factor` (preferred in lists,
// to avoid one query per row) OR a `sourceId` to look it up. Falls back to neutral.
export function TrustChip({
  factor,
  sourceId,
  className,
}: {
  factor?: number | null;
  sourceId?: string | null;
  className?: string;
}) {
  // Only fetch when a factor was not supplied.
  const { data: fetched } = useSourceCredibility(factor == null ? sourceId : null);
  const f = factor ?? fetched ?? null;
  const chip = trustChip(f);
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-md border px-1.5 py-0.5 font-body text-[10px] font-medium leading-none",
        toneSurface(chip.tone),
        className,
      )}
      title={chip.label}
    >
      {chip.label}
      {chip.glyph && <span aria-hidden>{chip.glyph}</span>}
    </span>
  );
}
